import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui-library/sheet';
import React, { useEffect, useRef } from 'react';

type iSideSheet = {
  isOpen?: boolean
  handleModalFunc?: () => void
  size?: string,
  title?: string,
  tabs?: React.ReactNode
  children?: React.ReactNode
  titleChildren?: React.ReactNode
  hasCrossIcon?: boolean
  onOpenAutoFocus?: (e: Event) => void
  onOpened?: () => void
  onClosed?: () => void
}

const SideSheet: React.FC<iSideSheet> = ({title, size, tabs, isOpen, handleModalFunc, children, titleChildren, hasCrossIcon = true, onOpened, onClosed, ...rest}) => {
  const wasOpenRef = useRef(false)

  useEffect(() => {
    console.log({isOpen})
    if (isOpen) {
      wasOpenRef.current = true
      onOpened?.()
    } else if (wasOpenRef.current) {
      wasOpenRef.current = false
      onClosed?.()
    }
    return () => {
      console.log('cleanup')
      wasOpenRef.current = false
      onClosed?.()
    }
  }, [isOpen])

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      handleModalFunc?.()
    }
  }

  const modalSize = (() => {
    switch (size) {
    case 'sm': return  '600px';
    case 'md': return '900px';
    case 'lg': return '1200px';
    default: return '600px';
    }
  })();

  const handlePointerDownOutside = (event: Event) => {
    const target = event.target as HTMLElement;
    if (!target.closest('[data-state="open"]')) {
      event.preventDefault();
    }
  };

  return (
    <Sheet open={isOpen} onOpenChange={handleOpenChange}>
      <SheetContent
        side={'right'}
        onOpenAutoFocus={(e) => e.preventDefault()}
        onPointerDownOutside={handlePointerDownOutside}
        className={
          'm-4 flex !max-w-none min-h-0 flex-col gap-0 overflow-hidden rounded-3xl border-none p-0 outline-none'
        }
        style={{ width: `${modalSize}`, height: '96%', maxHeight: '96vh' }}
        hasCrossIcon={hasCrossIcon}
        {...rest}
      >
        <SheetHeader className='shrink-0 rounded-t-3xl bg-primary_lighter p-0'>
          <SheetTitle className='w-full rounded-t-3xl bg-primary_lighter p-6 text-start text-lg font-medium text-dark'>
            {title || titleChildren}
          </SheetTitle>
          {tabs && <div className='ps-6'>{tabs}</div>}
        </SheetHeader>
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto overscroll-contain">{children}</div>
      </SheetContent>
    </Sheet>
  );
};

export default SideSheet;